import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";

const LandingPage = lazy(() => import("./pages/LandingPage"));
const AccountPage = lazy(() => import("./pages/AccountPage"));
const ExtensionInstalledPage = lazy(() => import("./pages/ExtensionInstalledPage"));
const ExtensionAuthorizePage = lazy(() => import("./pages/ExtensionAuthorizePage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));
const DeleteDataPage = lazy(() => import("./pages/DeleteDataPage"));
const HowItWorksPage = lazy(() => import("./pages/HowItWorksPage"));
const SharePage = lazy(() => import("./pages/SharePage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const AdminOpsPage = lazy(() => import("./pages/AdminOpsPage"));
const ChannelHistoryPage = lazy(() => import("./pages/ChannelHistoryPage"));

export function App() {
  return (
    <Suspense fallback={<main className="full-page-loading"><p>Opening TubeAgo…</p></main>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/ago" element={<Navigate replace to="/extension-installed" />} />
        <Route path="/channel" element={<ChannelHistoryPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/extension-installed" element={<ExtensionInstalledPage />} />
        <Route path="/extension/authorize" element={<ExtensionAuthorizePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/delete-my-data" element={<DeleteDataPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/s/:shareId" element={<SharePage />} />
        <Route path="/admin/ops" element={<AdminOpsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
